import { canv } from '@/canv/global.js'

export class touchEvent {

    constructor() {
    }

    init(UID) {
        this.event = {
            "type": "touch",
            "UID": UID,
        };
    }

    execEvent() {}

    checkEvent() {
        var entity = canv.canvasController.FindByUID(this.event["UID"]);
        if (entity == null) {
            return false;
        }

        return true;
    }

    getEvent() {
        return this.event;
    }

    loadEvent(event) {
        this.event = event;
    }

    getTwin() {
        let twin = new touchEvent();
        twin.init(this.event["UID"]);

        return twin;
    }





    event = {};


}